export default __webpack_public_path__ + "static/media/BB-logo-oed.1141a9af.png";